import { useCallback, useState } from "react";
import { movieRepository } from "../api/movieRepository";

/** @typedef {import("../types").Movie} Movie */
/** @typedef {import("../types").Video} Video */

/**
 * Detalle + trailer de la película actualmente seleccionada.
 * @param {typeof movieRepository} [repository]
 */
export function useSelectedMovie(repository = movieRepository) {
  const [selectedMovie, setSelectedMovie] = useState(/** @type {Movie|null} */ (null));
  const [trailer, setTrailer] = useState(/** @type {Video|null} */ (null));

  /** @param {Movie|null} movie */
  const selectMovie = useCallback(
    async (movie) => {
      if (!movie) {
        setSelectedMovie(null);
        setTrailer(null);
        return;
      }

      try {
        const { movie: movieDetails, trailer: movieTrailer } = await repository.getMovieWithTrailer(
          movie.id
        );

        setSelectedMovie(movieDetails || movie);
        setTrailer(movieTrailer);
      } catch (detailsError) {
        console.error("No se pudo cargar el detalle de la película.", detailsError);
        setSelectedMovie(movie);
        setTrailer(null);
      }
    },
    [repository]
  );

  return { selectedMovie, trailer, selectMovie };
}
